import { Touchpoint } from '../../ScriptingEngineEnvironment';
import { VFTDictionary } from './createValidationFailureTypeDictionary';
import { DPSValidationResult } from './types';

function cSharpFormat(formatString: string, replacements: any[]) {
    return formatString.replace(/{(\d+).*?}/g, (_, index) => {
        const value = replacements[index];

        if (value === undefined) {
            throw new Error(
                `Invalid replacements for format string. Format string required at least ${
                    parseInt(index, 10) + 1
                } replacements, but there are only ${replacements.length} replacements.`
            );
        }

        return value;
    });
}

function formatDefaultVFT(
    result: Touchpoint.DocumentValidation.ValidationResult,
    failureType: NonNullable<VFTDictionary[string]>
) {
    const { detailArguments, titleArguments } = result;

    return {
        titleText: cSharpFormat(failureType.TitleText, titleArguments),
        detailText: failureType.DetailText ? cSharpFormat(failureType.DetailText, detailArguments) : undefined,
    };
}

function formatCustomOverrideText({
    titleText,
    titleArguments,
    detailText,
    detailArguments,
}: {
    titleText: string;
    titleArguments: string[];
    detailText?: string;
    detailArguments: string[];
}) {
    return {
        titleText: cSharpFormat(titleText, titleArguments),
        detailText: detailText ? cSharpFormat(detailText, detailArguments) : undefined,
    };
}

export function transformToDPSValidationResult(
    { result, validationClass }: Touchpoint.DocumentValidation.ValidationClassResult,
    ValidationFailureType?: VFTDictionary[string],
    inputParameterOverrideText?: {
        titleText: string;
        titleArguments: string[];
        detailText?: string;
        detailArguments: string[];
    }
): DPSValidationResult {
    const defaultVFT = ValidationFailureType
        ? formatDefaultVFT(result, ValidationFailureType)
        : result.defaultVFT ?? null;

    return {
        errorCode: result.errorCode,
        titleArguments: result.titleArguments,
        detailArguments: result.detailArguments,
        defaultVFT: inputParameterOverrideText ? formatCustomOverrideText(inputParameterOverrideText) : defaultVFT,
        associatedUIField: result.associatedUIField,
        computedDisposition: result.computedDisposition,
        cloudCaptureDisposition: result.computedCloudCaptureDisposition,
        omitUIPrefix: validationClass === 'Warning' ? result.omitUIPrefix : undefined,
    };
}
